import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { logger } from '../utils/logger'

export function useNavigationLogger() {
  const location = useLocation()
  const navigate = useNavigate()

  // Логируем изменения маршрута
  useEffect(() => {
    logger.info('NAVIGATION', `Переход на страницу: ${location.pathname}`, {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      state: location.state
    })
  }, [location])

  // Создаем обертку для navigate с логированием
  const navigateWithLog = (to: string, options?: any) => {
    logger.info('NAVIGATION', `Навигация к: ${to}`, {
      from: location.pathname,
      to,
      options
    })
    navigate(to, options)
  }

  return { navigateWithLog }
}
